import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { WorkflowProposalProcess } from '~/components/WorkflowProposalProcess';
import { EmploymentDetailsProposalProps } from '~/data/proposals';
import { useEmployeeProposal } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmploymentDetail/data/useEmployeeProposal';
import { EmployeeProposalDecision } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const OngoingEmploymentDetailProposalDialog = ({
  proposal,
  open,
  onClose,
  onSubmit,
}: {
  proposal: EmploymentDetailsProposalProps;
  open: boolean;
  onClose: () => void;
  onSubmit: (
    proposal: EmploymentDetailsProposalProps,
    decision?: EmployeeProposalDecision,
  ) => void;
}) => {
  const { handleDecision, handleUltimateDecision } = useEmployeeProposal({
    proposal,
    onSubmit,
  });
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} sx={{ p: 3 }}>
      <DialogTitle>{t('laEMPLOYMENT_DETAILS_PROPOSAL')}</DialogTitle>
      <DialogContent>
        <WorkflowProposalProcess
          proposal={proposal}
          onDecision={(decision) => {
            handleDecision(decision);
            onClose();
          }}
          onUltimateDecision={(decision) => {
            handleUltimateDecision(decision);
            onClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          data-testid="emp-detail-proposal-dialog-close-button"
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
